require('@rails/ujs').start()
require('turbolinks').start()
require('inter-ui')

import './../web-player.js'
